import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-6ad08db5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mascot-menu" }


export default /*#__PURE__*/_defineComponent({
  __name: 'MascotMenu',
  props: {
    hasTutorials: { type: Boolean }
  },
  emits: ["open-tutorials", "open-feedback"],
  setup(__props: any) {





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.hasTutorials)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('open-tutorials')))
        }, "Tutorials"))
      : _createCommentVNode("", true),
    _createElementVNode("button", {
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('open-feedback')))
    }, "Feedback")
  ]))
}
}

})